import { InjectionToken } from '@angular/core';
import { environment } from '../../../../environments/environment';

export const API_ENDPOINT = new InjectionToken<string>('API_ENDPOINT', {
  providedIn: 'root',
  factory: () => environment.apiEndpoint,
});
export const TAG_API_ENDPOINT = new InjectionToken<string>('TAG_API_ENDPOINT', {
  providedIn: 'root',
  factory: () => environment.tagServerApiEndpoint,
});
export const AUDIT_API_ENDPOINT = new InjectionToken<string>(
  'AUDIT_API_ENDPOINT',
  {
    providedIn: 'root',
    factory: () => environment.auditTrailApiEndpoint,
  },
);
